export default __webpack_public_path__ + "5b49f4993ae22d7975b413caed1a4c01.ttf";